import { createContext, useContext } from 'react';

import { CardDetails, CardDetailsContextType } from './types';

export const emptyDetails: CardDetails = { CVV: '', PAN: '' };

export const CardDetailsContext = createContext<
  CardDetailsContextType | undefined
>(undefined);

export const useCardDetailsContext = () => {
  const context = useContext(CardDetailsContext);
  if (context === undefined) {
    throw new Error(
      'useCardDetailsContext must be used within a CardDetailsContextProvider',
    );
  }
  return context;
};
